import { Cluster } from '@cast/types';

import { useInstallKentScriptDialog } from 'features/kent/InstallKentScript';

import { useCastctlOnboardingDialog } from '../useCastctlOnboardingDialog';

import { isKentManagedCluster } from '@cast/shared-cluster-context-data-access';

export const useReconnectClusterDialog = () => {
  const { showInstallKentScript } = useInstallKentScriptDialog();
  const { openCastctlOnboardingDialog } = useCastctlOnboardingDialog();

  return {
    openReconnectDialog: (cluster: Cluster) => {
      if (isKentManagedCluster(cluster)) {
        showInstallKentScript({ cluster });
        return;
      }

      openCastctlOnboardingDialog({
        cluster,
        skipConnectionMonitoring: true,
      });
    },
  };
};
